import { Link, useLocation } from "react-router-dom";
import { useContext } from "react";
import { useSelector } from "react-redux";
import classes from "./CreatorNavBar.module.css";
import { NavBarContext } from "../../../App";       
import useUnreadMessagesCount from "../../../hooks/messages/useUnreadMessagesCount";
import useBookingNotifications from "../../../hooks/useBookingNotifications";
import { useHasStudios } from "../../../hooks/useHasStudios";

const CreatorNavBar = ({ onMessagesClick }) => {
    const location = useLocation();
    const { activeView } = useContext(NavBarContext);
    const { user } = useSelector((state) => state?.auth);
    const userId = user?.id || user?._id;
    const { hasStudios } = useHasStudios(userId);
    const unreadCount = useUnreadMessagesCount();
    
    // Only fetch booking notifications for hosts (creator mode)
    const isHost = hasStudios || activeView === 'creator';
    const bookingNotifications = useBookingNotifications(isHost ? activeView : null);
    
    const isActive = (path) => {
        // Special case: /services-studios should be active for both /services-studios and /preview/studio/:id paths
        if (path === '/services-studios') {
            const isServicesStudiosPath = location.pathname === '/services-studios' || location.pathname.startsWith('/services-studios/');
            const isPreviewStudioPath = /^\/preview\/studio\/[^/]+$/.test(location.pathname);
            return isServicesStudiosPath || isPreviewStudioPath;
        }
        return location.pathname === path || location.pathname.startsWith(path + '/');
    };

    return (
        <>
            <div className={classes.navigaitonHeader}>
            <Link to={`/creator`} style={{ position: 'relative', display: 'inline-block' }}>
                <h2 className={`semiboldSmall ${isActive('/creator') ? classes.activeState : classes.nonactiveState}`}>
                    Buchungen
                </h2>
                {bookingNotifications > 0 && (
                    <span style={{
                        position: 'absolute',
                        top: '-2px',
                        right: '-3px',
                        backgroundColor: '#DF315A',
                        borderRadius: '50%',
                        width: '8px',
                        height: '8px',
                        minWidth: '8px'
                    }}>
                    </span>
                )}
            </Link>
            <Link to="/calendar">
                <h2 className={`semiboldSmall ${isActive('/calendar') ? classes.activeState : classes.nonactiveState}`}>
                    Kalender
                </h2>
            </Link>
            <Link to="/services-studios">
                <h2 className={`semiboldSmall ${isActive('/services-studios') ? classes.activeState : classes.nonactiveState}`}>
                    Studios & Services
                </h2>
            </Link>
            <Link
                to="/messages"
                state={{ fromCreatorDetails: true }}
                onClick={onMessagesClick}
                style={{ position: 'relative', display: 'inline-block' }}
            >
                <h2 className={`semiboldSmall ${isActive('/messages') ? classes.activeState : classes.nonactiveState}`}>
                    Nachrichten
                </h2>
                {unreadCount > 0 && (
                    <span style={{
                        position: 'absolute',
                        top: '-4px',
                        right: '-8px',
                        backgroundColor: '#DF315A',
                        color: 'white',
                        borderRadius: '50%',
                        width: '18px',
                        height: '18px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: '600',
                        minWidth: '18px'
                    }}>
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                )}
            </Link>
        </div>
        </>
    );
};

export default CreatorNavBar;

